import { useState, useEffect, useMemo } from 'react';
import SelectQuote, { filterSymbolNames, getDefaultQuote } from '../../components/SelectQuote';
import { getSymbols } from '../../services/SymbolsService';

function Market24hCard(props) {
    const [allSymbols, setAllSymbols] = useState([]);
    const [quote, setQuote] = useState(getDefaultQuote());

    function onQuoteChange(event) {
        setQuote(event.target.value);
    }

    useEffect(() => {
        getSymbols(false)
            .then((symbols) => setAllSymbols(filterSymbolNames(symbols.rows, quote)))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
            })
    }, [quote]);

    const sortedSymbols = useMemo(() => {
        if (!allSymbols || allSymbols.length === 0) return [];
        
        return [...allSymbols].sort((a, b) => {
            const hasDataA = props.data[a] && props.data[a].close;
            const hasDataB = props.data[b] && props.data[b].close;
            
            if (hasDataA === hasDataB) {
                return a.localeCompare(b);
            }
            if (hasDataA && !hasDataB) return -1;
            return 1;
        }).slice(0, 10); // Limita a 10 itens
    }, [allSymbols, props.data]);

    function formatPrice(price) {
        if (!price || price === '0') return '-';
        return parseFloat(price).toFixed(8).substring(0, 10);
    }

    return (
        <div className="dashboard-card">
            <div className="dashboard-card-header">
                <h3 className="dashboard-card-title">Mercado 24h</h3>
                <SelectQuote onChange={onQuoteChange} value={quote} />
            </div>
            <div className="dashboard-card-content">
                {sortedSymbols && sortedSymbols.length > 0 ? (
                    sortedSymbols.map(symbol => {
                        const tickerData = props.data[symbol];
                        if (!tickerData) return null;
                        
                        return (
                            <div key={symbol} className="dashboard-card-item">
                                <div>
                                    <div className="dashboard-card-item-symbol">{symbol}</div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                                    <div className="dashboard-card-item-value">
                                        <span className="dashboard-card-item-label">Fechamento:</span>
                                        {formatPrice(tickerData.close)}
                                    </div>
                                    <div className="dashboard-card-item-value" style={{ fontSize: '0.8rem', color: '#a0a0a0' }}>
                                        <span className="dashboard-card-item-label">Abertura:</span>
                                        {formatPrice(tickerData.open)}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="dashboard-card-empty">Nenhum dado disponível</div>
                )}
            </div>
        </div>
    );
}

export default Market24hCard;














